var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Edit } from "@mui/icons-material";
import { Box, Chip, Dialog, Divider, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { purchaseOrderList, purchaseOrderPagingAPI } from "../../../api/url";
import { DocFileIconSVG, ImageFileIconSVG, PDFFileIconSVG } from "../../../assets/customIcons";
import { CrossIcon, EditIconCard } from "../../../assets/images";
import { MuiRightDrawer } from "../../../builderPackage/components";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { getByIdAPI, getListAPI } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { faintGray, mobilenoblack, secondaryTextGray } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate, getBackgroundColor, getColor } from "../../../utils/utils";
import { PurchaseOrderTabKeys } from "../../cancelPurchaseOrder/services/entity";
import StatusProgressPO from "../../cancelPurchaseOrder/statusProgressPO";
import { CustomCrossIcon } from "../../jobCardDetails/assets/customIcons";
import { DownloadIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import CancelDocument from "../../spareParts/purchaseRequistion/components/cancelDocument";
import { cancellationReasonPRListAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { FilterPurchaseOrder } from "../components/filterPurchaseOrder";
import { ItemsSectionGrid } from "../components/itemsSectionGrid";
import { purchaseOrderCancelAPI, purchaseOrderPagingAPICall } from "../services/apiCalls";
import { PurchaseOrderKeys } from "../services/entity";
import HeaderCatalogPageComponent from "../../../components/templates/headerCatalogPageUpdated";
var renderIcon = function (contentType) {
    var type = contentType === null || contentType === void 0 ? void 0 : contentType.split('.')[1];
    switch (type) {
        case 'png':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'jpg':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'jpeg':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'pdf':
            return /*#__PURE__*/ React.createElement(PDFFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'doc':
            return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        case 'docx':
            return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    fontSize: 40,
                    color: faintGray
                }
            });
        default:
            return null;
    }
};
export var PurchaseOrderList = function (props) {
    var _crud$PurchaseOrderTa, _crud$PurchaseOrderTa2, _crud$PurchaseOrderTa3, _crud$PurchaseOrderTa4, _crud$PurchaseOrderTa5, _crud$PurchaseOrderTa6, _crud$PurchaseOrderTa7, _crud$PurchaseOrderTa8, _crud$PurchaseOrderKe2, _crud$PurchaseOrderTa9, _crud$PurchaseOrderTa10, _rowData$row2, _rowData$row3, _crud$PurchaseOrderKe3, _purchaseOrderListKey;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useDispatch();
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var _b = useState([]), typeId = _b[0], settypeId = _b[1];
    var _c = useState(false), isFilterOpen = _c[0], setFilterOpen = _c[1];
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _d = useState(false), openDrawer = _d[0], setOpenDrawer = _d[1];
    var _e = useState(null), rowData = _e[0], setRowData = _e[1];
    var _f = useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var open = Boolean(anchorEl);
    var purchaseOrderListKey = useAppSelector(function (state) { return state.crud; }).purchaseOrderListKey;
    var _g = useState(0), totalAmount = _g[0], setTotalAmount = _g[1];
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    var _h = useState(false), openCancelPopUp = _h[0], setOpenCancelPopUp = _h[1];
    var _j = useState(''), rowId = _j[0], setRowId = _j[1];
    var scheduledDateTime = (_crud$PurchaseOrderTa = (_crud$PurchaseOrderTa2 = crud[PurchaseOrderTabKeys.GetPurchaseOrder]) === null || _crud$PurchaseOrderTa2 === void 0 || (_crud$PurchaseOrderTa2 = _crud$PurchaseOrderTa2.data) === null || _crud$PurchaseOrderTa2 === void 0 ? void 0 : _crud$PurchaseOrderTa2.ScheduledDateTime) !== null && _crud$PurchaseOrderTa !== void 0 ? _crud$PurchaseOrderTa : '-';
    var deliveryDateTime = (_crud$PurchaseOrderTa3 = (_crud$PurchaseOrderTa4 = crud[PurchaseOrderTabKeys.GetPurchaseOrder]) === null || _crud$PurchaseOrderTa4 === void 0 || (_crud$PurchaseOrderTa4 = _crud$PurchaseOrderTa4.data) === null || _crud$PurchaseOrderTa4 === void 0 ? void 0 : _crud$PurchaseOrderTa4.EstimateDeliveryDateTime) !== null && _crud$PurchaseOrderTa3 !== void 0 ? _crud$PurchaseOrderTa3 : '-';
    var createdDateTime = (_crud$PurchaseOrderTa5 = (_crud$PurchaseOrderTa6 = crud[PurchaseOrderTabKeys.GetPurchaseOrder]) === null || _crud$PurchaseOrderTa6 === void 0 || (_crud$PurchaseOrderTa6 = _crud$PurchaseOrderTa6.data) === null || _crud$PurchaseOrderTa6 === void 0 ? void 0 : _crud$PurchaseOrderTa6.CreatedOn) !== null && _crud$PurchaseOrderTa5 !== void 0 ? _crud$PurchaseOrderTa5 : '-';
    var data = (_crud$PurchaseOrderTa7 = (_crud$PurchaseOrderTa8 = crud[PurchaseOrderTabKeys.GetPurchaseOrder]) === null || _crud$PurchaseOrderTa8 === void 0 ? void 0 : _crud$PurchaseOrderTa8.data) !== null && _crud$PurchaseOrderTa7 !== void 0 ? _crud$PurchaseOrderTa7 : [];
    var handleRowCancelClick = function (id) {
        setRowId(id);
        setOpenCancelPopUp(true);
    };
    var handleCancelClose = function () {
        setOpenCancelPopUp(false);
    };
    // useEffect(() => {
    //     let request = {
    //         // ParentId:rowData.id,
    //         // EntityId:rowData.SchemaId,
    //         ParentId: '61bc8378-48b1-4832-ac32-10680900d235',
    //         EntityId: '097ae54b-d290-4063-8387-8b4e7b98be22'
    //     }
    //     const data = {
    //         id: '61bc8378-48b1-4832-ac32-10680900d235'
    //     }
    //     const attachData = {
    //         "PurchaseOrderId": "2e0deef3-6c84-4dff-9f53-895598b1e60c"
    //     }
    //     purchaseOrderStatusProgressTabApi({ request: request })
    //     purchaseOrderOtherTabApi({ request: attachData })
    //     GetPurchaseOrder({ request: data })
    // }, [])
    var totalAmountCount = function () {
        var c = 0;
        {
            var _crud$PurchaseOrderKe;
            (_crud$PurchaseOrderKe = crud[PurchaseOrderKeys.ItemsPaging]) === null || _crud$PurchaseOrderKe === void 0 || (_crud$PurchaseOrderKe = _crud$PurchaseOrderKe.data) === null || _crud$PurchaseOrderKe === void 0 || _crud$PurchaseOrderKe.map(function (item, index) {
                if (item !== null && item !== void 0 && item.Amount) {
                    c += item === null || item === void 0 ? void 0 : item.Amount;
                    setTotalAmount(c);
                }
            });
        }
    };
    var customActionColumns = [{
            field: 'EstimateDeliveryDateTime',
            headerName: 'Fulfilment date',
            valueFormatter: function (val) { return val ? dayjs(val).format('DD MMM, YYYY') : '-'; },
            minWidth: 120,
            flex: 1
        }, {
            field: 'PurchaseOrderCreatedDateTime',
            headerName: 'Created Date',
            valueFormatter: function (val) { return val ? dayjs(val).format('DD MMM, YYYY') : '-'; },
            minWidth: 120,
            flex: 1
        }, {
            field: 'StatusName',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$value;
                return /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$value = params === null || params === void 0 ? void 0 : params.value) !== null && _params$value !== void 0 ? _params$value : '-',
                    size: "small",
                    variant: "outlined",
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: (params === null || params === void 0 ? void 0 : params.value) == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "red"
                    }) : undefined
                });
            },
            minWidth: 100,
            flex: 1
        }, {
            field: 'OrderPriority',
            headerName: 'Priority',
            renderCell: function (params) {
                var _params$row$PurchaseO, _params$row, _params$row2, _params$row3;
                return /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$PurchaseO = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.PurchaseOrderPriorityName) !== null && _params$row$PurchaseO !== void 0 ? _params$row$PurchaseO : '-',
                    size: "small",
                    variant: "outlined",
                    sx: {
                        borderRadius: '6px',
                        fontWeight: 'bold',
                        color: getColor(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.PurchaseOrderPriorityName),
                        backgroundColor: getBackgroundColor(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.PurchaseOrderPriorityName),
                        border: 'none',
                        padding: '2px 8px 2px 8px'
                    }
                });
            },
            minWidth: 100,
            flex: 1
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                return [/*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "Edit",
                        icon: /*#__PURE__*/ React.createElement(Edit, null),
                        onClick: function () {
                            var _params$row4;
                            return navigate("/createPurchaseOrder/edit/".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.id));
                        },
                        showInMenu: true
                    }), /*#__PURE__*/ React.createElement(GridActionsCellItem, {
                        label: "Cancel",
                        icon: /*#__PURE__*/ React.createElement(CustomCrossIcon, {
                            style: {
                                height: "16px",
                                width: "16px"
                            }
                        }),
                        showInMenu: true,
                        onClick: function () {
                            var _params$row5;
                            return handleRowCancelClick(params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.id);
                        }
                    })];
            }
        }];
    var step1 = [{
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            padding: 2,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'Total items',
                    label: 'Total items',
                    value: null,
                    columnSize: 6,
                    children: ((_crud$PurchaseOrderKe2 = crud[PurchaseOrderKeys.ItemsPaging]) === null || _crud$PurchaseOrderKe2 === void 0 ? void 0 : _crud$PurchaseOrderKe2.count) || '0',
                    labelTypographyProps: {
                        variant: "subtitle2",
                        color: "#8593A3"
                    },
                    variant: "h2"
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Total Amount (₹)',
                    label: 'Total Amount (₹)',
                    value: null,
                    columnSize: 6,
                    children: totalAmount,
                    labelTypographyProps: {
                        variant: "subtitle2",
                        color: "#8593A3"
                    },
                    variant: "h2"
                }]
        }, {
            type: FormItemTypes.Custom,
            name: "items",
            label: '',
            value: null,
            element: function () {
                var _rowData$row;
                return /*#__PURE__*/ React.createElement(ItemsSectionGrid, {
                    PO_ID: rowData === null || rowData === void 0 || (_rowData$row = rowData.row) === null || _rowData$row === void 0 ? void 0 : _rowData$row.PurchaseOrderId
                });
            },
            columnSize: 12
        }];
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var step2 = [{
            type: FormItemTypes.Custom,
            name: "StatusProgressPO",
            label: '',
            value: null,
            containerProps: {
                padding: 2
            },
            columnSize: 12,
            element: StatusProgressPO
        }];
    var step3 = [{
            type: FormItemTypes.Typography,
            name: "Reference",
            label: 'Reference number',
            value: null,
            children: (_crud$PurchaseOrderTa9 = (_crud$PurchaseOrderTa10 = crud[PurchaseOrderTabKeys.GetPurchaseOrder]) === null || _crud$PurchaseOrderTa10 === void 0 || (_crud$PurchaseOrderTa10 = _crud$PurchaseOrderTa10.data) === null || _crud$PurchaseOrderTa10 === void 0 ? void 0 : _crud$PurchaseOrderTa10.ReferenceNumber) !== null && _crud$PurchaseOrderTa9 !== void 0 ? _crud$PurchaseOrderTa9 : '-',
            columnSize: 6,
            variant: 'h6',
            labelTypographyProps: {
                variant: 'subtitle2',
                color: 'gray'
            }
        }, {
            type: FormItemTypes.Typography,
            name: "Delivery",
            label: 'Delivery date',
            value: null,
            valueGetter: function (data) {
                var _dateFormate;
                return (_dateFormate = dateFormate(data === null || data === void 0 ? void 0 : data.finaldeliveryFormat)) !== null && _dateFormate !== void 0 ? _dateFormate : '-';
            },
            columnSize: 6,
            variant: 'h6',
            labelTypographyProps: {
                variant: 'subtitle2',
                color: 'gray'
            }
        }, {
            type: FormItemTypes.Typography,
            name: "Scheduled2",
            label: 'Scheduled date',
            value: null,
            valueGetter: function (data) {
                var _dateFormate2;
                return (_dateFormate2 = dateFormate(data === null || data === void 0 ? void 0 : data.finalScheduledFormat)) !== null && _dateFormate2 !== void 0 ? _dateFormate2 : '-';
            },
            columnSize: 12,
            variant: 'h6',
            labelTypographyProps: {
                variant: 'subtitle2',
                color: 'gray'
            }
        }, {
            type: FormItemTypes.Custom,
            name: "Divider2",
            label: '',
            value: null,
            columnSize: 12,
            element: function () { /*#__PURE__*/ return React.createElement(Divider, null); }
        }, {
            type: FormItemTypes.Typography,
            name: "Created",
            label: 'Created by',
            value: null,
            columnSize: 6,
            variant: 'h6',
            labelTypographyProps: {
                variant: 'subtitle2',
                color: 'gray'
            }
        }, {
            type: FormItemTypes.Typography,
            name: "date",
            label: 'Created date',
            value: null,
            valueGetter: function (data) {
                var _dateFormate3;
                return (_dateFormate3 = dateFormate(data === null || data === void 0 ? void 0 : data.finalCreatedFormat)) !== null && _dateFormate3 !== void 0 ? _dateFormate3 : '-';
            },
            columnSize: 6,
            variant: 'h6',
            labelTypographyProps: {
                variant: 'subtitle2',
                color: 'gray'
            }
        }, {
            type: FormItemTypes.Custom,
            name: "DividerOtherTab",
            label: '',
            value: null,
            columnSize: 12,
            element: function () { /*#__PURE__*/ return React.createElement(Divider, null); }
        }, {
            type: FormItemTypes.List,
            name: "Attachments",
            label: 'Attachments',
            value: null,
            columnSize: 12,
            variant: 'compact',
            columns: [{
                    field: 'Icon',
                    maxWidth: 40,
                    renderCell: function (params) { return renderIcon(params.row.Name); }
                }, {
                    field: 'Name',
                    flex: 1
                }, {
                    field: 'Size',
                    width: 80,
                    valueFormatter: function (value) { return "".concat(Math.round(value / 1000), " KB"); }
                }],
            disableCheckboxSelection: true,
            rowHeight: 72
        }];
    var tabs = [{
            id: '0',
            label: 'Items',
            elements: step1
        }, {
            id: '1',
            label: 'Status Progress',
            elements: step2
        }, {
            id: '2',
            label: 'Other',
            elements: step3
        }];
    var viewOptions = ["My orders", "All orders"];
    var _k = useState(viewOptions.length > 0 && isAllViewActive ? viewOptions[0] : viewOptions[1]), selectedListVariant = _k[0], setSelectedListVariant = _k[1];
    var onNewClick = function () {
        navigate('/createPurchaseOrder');
    };
    var handleClose = function (event) {
        setAnchorEl(null);
    };
    var onDropDownArrowclick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _POList$payload, POList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "purchaseOrderListKey",
                        url: purchaseOrderList,
                        request: {}
                    }))];
                case 1:
                    POList = _a.sent();
                    if (POList !== null && POList !== void 0 && (_POList$payload = POList.payload) !== null && _POList$payload !== void 0 && (_POList$payload = _POList$payload.value) !== null && _POList$payload !== void 0 && _POList$payload.success) {
                        setAnchorEl(event.target.parentElement);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickFilterIcon = function () {
        setFilterOpen(function (prev) { return !prev; });
    };
    var formDataMoreDetail = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            label: '',
            flexDirection: 'row',
            columnSize: 12,
            marginTop: IS_DESKTOP ? 8 : 0,
            justifyContent: 'space-between',
            padding: '20px 0px',
            spacing: 0,
            rowSpacing: 3,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'header',
                    label: 'More Details',
                    columnSize: 11,
                    labelTypographyProps: {
                        variant: 'h1',
                        color: mobilenoblack,
                        paddingX: '24px'
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: 'Close',
                    columnSize: 1,
                    size: 'large',
                    children: /*#__PURE__*/ React.createElement("img", {
                        id: "crossIconBtn",
                        color: secondaryTextGray,
                        src: CrossIcon,
                        onClick: function () { return setOpenDrawer(false); }
                    }),
                    sx: {
                        padding: ' 0px 24px 0px 0px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            bgcolor: '#EFF2F5',
            pb: 2,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'PO_NUMBER',
                    label: 'PO NUMBER',
                    value: null,
                    columnSize: 6,
                    children: (rowData === null || rowData === void 0 || (_rowData$row2 = rowData.row) === null || _rowData$row2 === void 0 ? void 0 : _rowData$row2.DocumentNumber) || '-',
                    paddingLeft: 3,
                    labelTypographyProps: {
                        paddingLeft: 3
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'PO TYPE',
                    label: 'PO_TYPE',
                    value: null,
                    columnSize: 6,
                    children: (rowData === null || rowData === void 0 || (_rowData$row3 = rowData.row) === null || _rowData$row3 === void 0 ? void 0 : _rowData$row3.PurchaseOrderTypeName) || '-',
                    paddingRight: 3,
                    labelTypographyProps: {
                        paddingRight: 3,
                        display: 'flex',
                        justifyContent: 'flex-end'
                    },
                    display: "flex",
                    justifyContent: "flex-end"
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            tabs: tabs,
            variant: 'fullWidth',
            displayExpr: 'label',
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: 3,
                    pb: '90px'
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            position: 'fixed',
            width: {
                xs: '100%',
                sm: '600px'
            },
            justifyContent: 'end',
            bottom: 0,
            right: 0,
            spacing: 0,
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            borderTop: "1px solid ".concat(faintGray),
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'editButton',
                    value: null,
                    children: 'Edit',
                    columnSize: 0,
                    startIcon: /*#__PURE__*/ React.createElement("img", {
                        id: "moreDetail-edit-img",
                        src: EditIconCard,
                        alt: "Error"
                    }),
                    sx: {
                        background: 'none',
                        border: '1px solid #DEE4EB',
                        color: "".concat(systemColor.darkGrey)
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'DownloadPDF',
                    value: null,
                    children: 'Download as PDF',
                    columnSize: 0,
                    startIcon: /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                        sx: {
                            width: 20,
                            height: 20,
                            color: systemColor.primary
                        }
                    }),
                    sx: {
                        background: 'none',
                        border: "1px solid ".concat(systemColor.primary)
                    }
                }]
        }];
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var handleRowClick = function (row) {
        setRowData(row);
        setOpenDrawer(true);
        totalAmountCount();
    };
    var handleDrawerClose = function () {
        setRowData(undefined);
        setOpenDrawer(false);
    };
    var onTypeClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var POTypeClick;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: PurchaseOrderKeys.Paging,
                        url: purchaseOrderPagingAPI,
                        request: {
                            Type: typeId,
                            take: 10,
                            skip: 0
                        }
                    }))];
                case 1:
                    POTypeClick = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        purchaseOrderPagingAPICall({
            key: PurchaseOrderKeys.Paging,
            request: getRequest(),
            url: purchaseOrderPagingAPI
        });
    }, [selectedListVariant, filterValue]);
    var getRequest = function () {
        var _getLocalStorageItem;
        var filter = filterValue === null || filterValue === void 0 ? void 0 : filterValue.data;
        var request = {
            // Branches:['5e75d742-c9a5-429e-b825-a80e21208d36'],
            FromDate: filter !== null && filter !== void 0 && filter.FromDate ? filter === null || filter === void 0 ? void 0 : filter.FromDate : "",
            ToDate: filter !== null && filter !== void 0 && filter.ToDate ? filter === null || filter === void 0 ? void 0 : filter.ToDate : filter !== null && filter !== void 0 && filter.FromDate ? filter === null || filter === void 0 ? void 0 : filter.FromDate : "",
            IdentityId: selectedListVariant === "My orders" ? (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId : undefined
        };
        if (filter !== null && filter !== void 0 && filter.Type) {
            var _filter$Type;
            request = _objectSpread(_objectSpread({}, request), {}, {
                Type: filter === null || filter === void 0 || (_filter$Type = filter.Type) === null || _filter$Type === void 0 ? void 0 : _filter$Type.map(function (item) { return item.PurchaseOrderTypeId; })
            });
        }
        if (filter !== null && filter !== void 0 && filter.Priority) {
            var _filter$Priority;
            request = _objectSpread(_objectSpread({}, request), {}, {
                Priority: filter === null || filter === void 0 || (_filter$Priority = filter.Priority) === null || _filter$Priority === void 0 ? void 0 : _filter$Priority.map(function (item) { return item.Name; })
            });
        }
        return request;
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: viewOptions
    }), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: viewOptions.length > 0 ? viewOptions : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$PurchaseOrderKe3 = crud[PurchaseOrderKeys.Paging]) === null || _crud$PurchaseOrderKe3 === void 0 ? void 0 : _crud$PurchaseOrderKe3.count,
        onButtonClick: function () {
            navigate('/createPurchaseOrder');
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.PurchaseOrder,
        addButtonDropdown: true,
        onDropDownClick: onDropDownArrowclick
    }), /*#__PURE__*/ React.createElement(Box, {
        px: 2,
        marginTop: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: PurchaseOrderKeys.Paging,
        getPagingData: purchaseOrderPagingAPICall,
        pagingAPIRequest: getRequest(),
        columns: customActionColumns,
        dataGridProps: {
            onCellClick: function (params, event) {
                if (!((params === null || params === void 0 ? void 0 : params.field) == 'actions')) {
                    handleRowClick(params);
                }
            },
            disableColumnMenu: false
        }
    })), /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: openDrawer,
        onClose: handleDrawerClose,
        width: "70%"
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formDataMoreDetail
    })), /*#__PURE__*/ React.createElement(FilterPurchaseOrder, {
        isFilterOpen: isFilterOpen,
        setFilterOpen: handleClickFilterIcon
    }), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose
    }, purchaseOrderListKey === null || purchaseOrderListKey === void 0 || (_purchaseOrderListKey = purchaseOrderListKey.data) === null || _purchaseOrderListKey === void 0 ? void 0 : _purchaseOrderListKey.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: index,
            value: item.id,
            style: {
                textWrap: "pretty",
                overflowX: "scroll",
                textTransform: 'capitalize',
                width: '100%',
                height: '42px',
                fontWeight: 500,
                fontSize: 14,
                fontFamily: 'NotoSans-Medium'
            },
            onClick: function (event) {
                setAnchorEl(null);
                settypeId([item === null || item === void 0 ? void 0 : item.PurchaseOrderTypeId]);
                onTypeClick();
            }
        }, item.DisplayName);
    })), /*#__PURE__*/ React.createElement(Dialog, {
        maxWidth: "xs",
        open: openCancelPopUp,
        onClose: handleCancelClose
    }, /*#__PURE__*/ React.createElement(CancelDocument, {
        openPopper: openCancelPopUp,
        cancellationReasonAPI: cancellationReasonPRListAPICall,
        cancelAPI: purchaseOrderCancelAPI,
        id: rowId,
        handleClose: handleCancelClose
    })));
};
